<app-page-content>
<app-doenkids-menu-bar menuBar [showBackButton]="true" [loading]="isLoading$ | async">
  <div left class="flex-1 flex-row items-center justify-start">
    @if ((hasWriteAccess$ | async)) {
      <button
        mat-icon-button
        type="button"
        (click)="save()"
        [disabled]="!isTheOwner"
        [matTooltip]="'program.template_bundle.template.save.tooltip' | translate"
        >
        <mat-icon>save</mat-icon>
      </button>
    }
    <button
      mat-icon-button
      type="button"
      (click)="downloadPoster()"
      [matTooltip]="'program.template_bundle.poster.download.tooltip' | translate"
      [disabled]="!(bundle$ | async)?.media_uuid"
      >
      <mat-icon>get_app</mat-icon>
    </button>
    @if (!(isReader$| async) && (baseOnly$ | async) && !(isApproved$ | async) && !(approveIsTranslate$ | async)) {
      <button
        mat-icon-button
        type="button"
        (click)="approveBundle()"
        [matTooltip]="'program.template_bundle.approve.tooltip' | translate"
        >
        <mat-icon>done_all</mat-icon>
      </button>
    }
    @if (!(isReader$| async) && (approveIsTranslate$ | async)) {
      <button
        mat-icon-button
        (click)="forkBundle(true)"
        [matTooltip]="'program_template_bundle.translate.tooltip' | translate"
        >
        <mat-icon>translate</mat-icon>
      </button>
    }
    @if (!(isReader$ | async) && !(hasWriteAccess$ | async) && (isApproved$ | async)) {
      <button
        color="primary"
        mat-icon-button
        type="button"
        (click)="removeApproval()"
        [matTooltip]="'program.template_bundle.approval.remove.tooltip' | translate"
        >
        <mat-icon>done_all</mat-icon>
      </button>
    }
    @if (!(showMobileLayout$ | async)) {
      @if (bundleOwner$ | async; as bundleOwner) {
        <app-owner-chip
          [(isTheOwner)]="isTheOwner"
          (isTheOwnerChange)="handleIsTheOwnerChange($event)"
          [owningOuId]="bundleOwner.organization_unit_id"
        ></app-owner-chip>
      }
    }
    @if (!(isReader$ | async) && (canBeForked$ | async) && !(approveIsTranslate$ | async)) {
      <button mat-icon-button type="button" (click)="forkBundle()" [matTooltip]="'program.template_bundle.fork.tooltip' | translate">
        <mat-icon class="icon-btn">call_split</mat-icon>
      </button>
    }
    <ng-container *ngVar="possibleContentLanguages$ | async as contentLanguages">
      @if (!(baseOnly$ | async) && (hasWriteAccess$ | async) && contentLanguages?.length > 1) {
        <mat-form-field
          appearance="outline"
          class="compact-select content-language-select"
          >
          <mat-label>{{ 'program_template_bundle.content_language.label' | translate }}</mat-label>
          <mat-select [formControl]="contentLanguageControl">
            @if (contentLanguageControl.value) {
              <mat-select-trigger>
                <mat-icon [svgIcon]="contentLanguageControl.value.toLowerCase()"></mat-icon>
                {{ 'generic.language.' + contentLanguageControl.value.toLowerCase() | translate }}
              </mat-select-trigger>
            }
            @for (contentLanguage of contentLanguages; track contentLanguage) {
              <mat-option [value]="contentLanguage">
                <mat-icon [svgIcon]="contentLanguage.toLowerCase()"></mat-icon>
                {{ 'generic.language.' + contentLanguage.toLowerCase() | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </ng-container>
  </div>
  <div right class="right-menu-bar-actions">
    @if (!(showMobileLayout$ | async)) {
      @if (!(baseOnly$ | async) && (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async) && (bundle$ | async)?.program_template_status_id; as statusId) {
        <app-status-chip
          [statusName]="getProgramTemplateBundleStatusName(statusId)"
          [translationKey]="'program.status.' + getProgramTemplateBundleStatusName(statusId)"
        ></app-status-chip>
        @if ((hasWriteAccess$ | async) && isTheOwner) {
          <app-publish-button
            [currentStatusName]="getProgramTemplateBundleStatusName(statusId)"
            [hasWriteAccess]="(hasWriteAccess$ | async) && isTheOwner"
            [statusOptions]="getBundleStatusOptionsForMenu(statusId)"
            [publishTooltip]="getProgramTemplateBundleStatusName(statusId) === 'published' ? ('program_details.status.already_published' | translate) : ('program.status.publish' | translate)"
            [optionsTooltip]="'program.status.options' | translate"
            menuId="bundleStatusOptionsMenu"
            (publish)="publishBundle()"
            (statusSelected)="changePublicationStatus($event)"
          ></app-publish-button>
        }
      }
    }

    @if (
      !(isRevoked$ | async) &&
      ((isAdmin$ | async) || ((!(isRootNode$ | async) || (baseOnly$ | async)) && (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async)))
      ) {
      <button
        mat-icon-button
        type="button"
        (click)="excludeProgramTemplateBundle()"
        [matTooltip]="'program.template_bundle.exclude.tooltip' | translate"
        >
        <mat-icon>remove_circle</mat-icon>
      </button>
    }
    @if ((hasWriteAccess$ | async)) {
      <button mat-icon-button type="button" [disabled]="!isTheOwner" (click)="removeBundle()" [matTooltip]="'program.template_bundle.remove.tooltip' | translate">
        <mat-icon>delete</mat-icon>
      </button>
    }
  </div>
</app-doenkids-menu-bar>
<div content>
  <div class="page-container">
    <form [formGroup]="this.programBundleForm">
    @if (showMobileLayout$ | async) {
      @if (bundle$ | async; as bundle) {
        <div class="mobile-chips-section">
          <div class="flex-row items-center justify-start flex-wrap gap-2">
            @if (bundleOwner$ | async; as bundleOwner) {
              <app-owner-chip
                [(isTheOwner)]="isTheOwner"
                (isTheOwnerChange)="handleIsTheOwnerChange($event)"
                [owningOuId]="bundleOwner.organization_unit_id"
              ></app-owner-chip>
            }
            @if (!(baseOnly$ | async) && (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async) && bundle.program_template_status_id; as statusId) {
              <app-status-chip
                [statusName]="getProgramTemplateBundleStatusName(statusId)"
                [translationKey]="'program.status.' + getProgramTemplateBundleStatusName(statusId)"
              ></app-status-chip>
              @if ((hasWriteAccess$ | async) && isTheOwner) {
                <app-publish-button
                  [currentStatusName]="getProgramTemplateBundleStatusName(statusId)"
                  [hasWriteAccess]="(hasWriteAccess$ | async) && isTheOwner"
                  [statusOptions]="getBundleStatusOptionsForMenu(statusId)"
                  [publishTooltip]="getProgramTemplateBundleStatusName(statusId) === 'published' ? ('program_details.status.already_published' | translate) : ('program.status.publish' | translate)"
                  [optionsTooltip]="'program.status.options' | translate"
                  menuId="bundleStatusOptionsMenuMobile"
                  (publish)="publishBundle()"
                  (statusSelected)="changePublicationStatus($event)"
                ></app-publish-button>
              }
            }
          </div>
        </div>
      }
    }
    @if (bundle$ | async; as bundle) {
      <div class="main-details flex-col md-flex-row items-start justify-start gap-4">
        @if (!(hasWriteAccess$ | async)) {
          <div class="bundle-details flex-col md-flex-row">
            <app-doenkids-image [maxHeight]="500" [maxWidth]="500" [mediaItem]="bundle.media_uuid" [showOriginType]="true"></app-doenkids-image>
            <div class="bundle-contents flex-col">
              <h1>{{ bundle.name }}</h1>
              <div class="content" [innerHTML]="programBundleForm.get('content').value"></div>
              <div class="download-buttons flex-row gap-4">
                <button mat-flat-button color="primary" type="button" (click)="downloadPoster()">
                  {{ 'program.template_bundle.poster.download.label' | translate }}
                </button>
                @if ((hasProgramExplanationPermission$ | async) && (programTemplateBundleExplanationAttachments$ | async)?.length > 0) {
                  @for (attachment of programTemplateBundleAttachments$ | async; track attachment) {
                    <button mat-flat-button color="primary" type="button" (click)="downloadAttachment(attachment, $event)">
                      {{
                      'program.template_bundle.attachment.download.label'
                      | translate
                      : {
                      filename: attachment.display_name ? attachment.display_name : attachment.filename
                    }
                    }}
                  </button>
                }
              }
              @if ((programTemplateBundleAttachments$ | async)?.length > 0) {
                @for (attachment of programTemplateBundleAttachments$ | async; track attachment; let index = $index) {
                  @if (index < currentTemplateAttachmentLimit) {
                    <button mat-flat-button color="primary" type="button" (click)="downloadAttachment(attachment, $event)">
                      {{
                      'program.template_bundle.attachment.download.label'
                      | translate
                      : {
                      filename: attachment.display_name ? attachment.display_name : attachment.filename
                    }
                    }}
                  </button>
                }
              }
            }
            @if ((programTemplateBundleAttachments$ | async)?.length > currentTemplateAttachmentLimit) {
              <button mat-flat-button color="primary" type="button" (click)="loadMoreAttachments()">...</button>
            }
          </div>
        </div>
      </div>
      <div class="bundle-metadata">
        <p>
          <span>{{ 'program.template_bundle.suitable_for.description' | translate }}</span>
          @for (activity_type of okoTypes$ | async; track activity_type; let isLast = $last) {
            <span> {{ activity_type.name }}{{ isLast ? '' : ',&nbsp;' }} </span>
          }
        </p>
        @if (programBundleForm.get('program_category').value) {
          <div>
            <span>{{ 'program.template_bundle.category.label' | translate }}</span>
            @for (category of programCategories$ | async; track category) {
              @if (category.id === programBundleForm.get('program_category').value) {
                <span>{{ category.name }}</span>
              }
            }
          </div>
        }
      </div>
    }
    @if (hasWriteAccess$ | async) {
      <div class="bundle-details">
        <app-asset-upload [class.full-width]="isSmall$ | async" identifier="template-cover" purpose="program-template" (uploaded)="addCoverImage($event)">
          <ng-template let-uploadData="uploadData">
            <div class="image-container">
              <app-doenkids-image
                [maxWidth]="500"
                [maxHeight]="500"
                [preview]="true"
                [mediaItem]="this.programBundleForm.get('media_uuid').value"
                [showOriginType]="true"
                >
                <app-select-media
                  identifier="template-cover"
                  [uploadData]="uploadData"
                  [removable]="this.programBundleForm.get('media_uuid').value"
                  (selected)="addCoverImage($event)"
                  purpose="program-template"
                  >
                </app-select-media>
              </app-doenkids-image>
            </div>
          </ng-template>
        </app-asset-upload>
      </div>
      <div class="bundle-contents">
        <div class="form-fields">
          <mat-form-field appearance="outline" [class.full-width]="isSmall$ | async">
            <mat-label>{{ 'program.template_bundle.name.label' | translate }}</mat-label>
            <input type="text" formControlName="name" matInput />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'program.template_bundle.category.label' | translate }}</mat-label>
            <mat-select formControlName="program_category">
              @for (category of programCategories$ | async; track category) {
                <mat-option [value]="category.id">{{ category.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'program.template_bundle.suitable_for.label' | translate }}</mat-label>
              <mat-select formControlName="type_oko">
                @for (okoType of okoTypes$ | async; track okoType) {
                  <mat-option [value]="okoType.id">{{ okoType.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="template-content">
          <span class="template-content-title">{{ 'program.template_bundle.content.title' | translate }}</span>
          <div class="editing-content">
            <quill-editor
              bounds="self"
              theme="bubble"
              formControlName="content"
              appOnFocus
              [placeholder]="'program.template_bundle.content.placeholder' | translate"
            ></quill-editor>
          </div>
        </div>
      </div>
    }
  </div>
}
</form>

@if ((hasProgramExplanationPermission$ | async) && (hasWriteAccess$ | async)) {
  <div class="attachments">
    <h2 class="title">
      <span>{{ 'program.template_bundle.explanations.label' | translate }}</span>
      @if (isTheOwner) {
        <button mat-button (click)="addExplanationAttachment()">
          <mat-icon>note_add</mat-icon>
          {{ 'generic.upload' | translate | lowercase }}
        </button>
      }
    </h2>
    <mat-divider></mat-divider>
    <div class="attachment-container">
      @for (attachment of programTemplateBundleExplanationAttachments$ | async; track attachment) {
        <div
          class="attachment flex-row justify-between items-center"
          (click)="editAttachment(attachment, $event)"
          >
          <div class="flex-row items-center justify-start">
            <mat-icon>attachment</mat-icon>&nbsp;&nbsp; <span>{{ attachment.display_name ? attachment.display_name : attachment.filename }}</span
            >&nbsp;
            <span> — ({{ attachment.created_at | i18n_date : 'dd/MM/yyyy' | async }})</span>
          </div>
          @if (isTheOwner) {
            <button mat-icon-button type="button" (click)="removeAttachment($event, attachment)">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      }
    </div>
  </div>
}

@if (hasWriteAccess$ | async) {
  <div class="attachments">
    <div class="flex-row justify-between items-center">
      <h2 class="title">
        {{ 'program.template_bundle.attachments.label' | translate }}
      </h2>
      @if (isTheOwner) {
        <button
          class="attachment-upload-button"
          mat-icon-button
          type="button"
          (click)="addAttachment()"
          [matTooltip]="'generic.upload' | translate"
          >
          <mat-icon>note_add</mat-icon>
        </button>
      }
    </div>
    <mat-divider></mat-divider>
    <div class="attachment-container">
      @for (attachment of programTemplateBundleAttachments$ | async; track attachment) {
        <div
          class="attachment flex-row justify-between items-center"
          (click)="previewAttachment(attachment)"
          >
          <div class="flex-row items-center justify-start">
            <mat-icon>attachment</mat-icon>&nbsp;&nbsp; <span>{{ attachment.display_name ? attachment.display_name : attachment.filename }}</span
            >&nbsp;
            <span> — ({{ attachment.created_at | i18n_date : 'dd/MM/yyyy' | async }})</span>
          </div>
          <div class="attachment-buttons flex-row justify-end">
            @if (isTheOwner) {
              <button
                mat-icon-button
                type="button"
                (click)="downloadAttachment(attachment, $event)"
                [matTooltip]="'generic.download' | translate"
                >
                <mat-icon>download</mat-icon>
              </button>
            }
            @if (isTheOwner) {
              <button
                mat-icon-button
                type="button"
                (click)="editAttachment(attachment, $event)"
                [matTooltip]="'program.template_bundle.preview.update_name.tooltip' | translate"
                >
                <mat-icon>edit</mat-icon>
              </button>
            }
            @if (isTheOwner) {
              <button mat-icon-button type="button" (click)="removeAttachment($event, attachment)" [matTooltip]="'generic.delete' | translate">
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>
}

@if (templatesWithTags; as templates) {
  <div>
    @if (templates.length > 1 && (hasWriteAccess$ | async) && isTheOwner) {
      <div class="templates-icons">
        @if (!isReOrdering$.value) {
          <button
            mat-icon-button
            type="button"
            (click)="toggleReOrdering()"
            [matTooltip]="'program.template_bundle.reorder.enable.tooltip' | translate"
            >
            <mat-icon>view_list</mat-icon>
          </button>
        }
        @if (isReOrdering$.value) {
          <button
            mat-icon-button
            type="button"
            (click)="toggleReOrdering()"
            [matTooltip]="'program.template_bundle.reorder.disable.tooltip' | translate"
            >
            <mat-icon>view_column</mat-icon>
          </button>
        }
      </div>
    }
    @if (!isReOrdering$.value) {
      @if (templates.length > 0) {
        <swiper-container id="templates" class="swiper-container" dkSwiper [config]="config" init="false">
          @for (template of templates; track template) {
            <swiper-slide class="swiper-slide" (click)="openProgramTemplate(template)">
              <div class="template-image">
                @if (template.language !== (bundle$ | async)?.language) {
                  <div class="switch-template-actions">
                    <mat-icon [svgIcon]="template.language.toLowerCase()"></mat-icon>
                    @if (isTheOwner) {
                      <button
                        mat-icon-button
                        type="button"
                        (click)="replaceTemplate($event, template)"
                        [matTooltip]="'program_template_bundle.swap_template.tooltip' | translate"
                        >
                        <mat-icon>swap_horiz</mat-icon>
                      </button>
                    }
                  </div>
                }
                <app-doenkids-image [mediaItem]="template.media_uuid" [maxWidth]="200"></app-doenkids-image>
              </div>
              <div class="bundle-template-content">
                <div class="template-content-tags">
                  <mat-chip-listbox hideSingleSelectionIndicator>
                    @for (templateTag of template.tags; track templateTag) {
                      <mat-chip-option>{{ templateTag.name }}</mat-chip-option>
                    }
                    @if ((hasWriteAccess$ | async) && isTheOwner) {
                      <button
                        mat-button
                        class="tag-add-button"
                        color="primary"
                        [matTooltip]="'program.template_bundle.tags.edit.tooltip' | translate"
                        (click)="openTagDialogForProgram($event, template)"
                        >
                        <mat-icon
                    [attr.aria-label]="
                      'program.template_bundle.tags.edit.label'
                        | translate
                          : {
                              templateName: template.name
                            }
                    "
                        >push_pin</mat-icon
                        >
                        <span class="tag-add-button-text">
                          {{ 'program.template_bundle.tags.edit.text' | translate }}
                          <mat-icon>arrow_right</mat-icon>
                        </span>
                      </button>
                    }
                  </mat-chip-listbox>
                </div>
                <span class="bundle-template-content-title"
                  ><strong>{{ template.name }}</strong></span
                  >
                  <div [innerHTML]="template.content"></div>
                </div>
              </swiper-slide>
            }
          </swiper-container>
        }
      }
      @if (isReOrdering$.value) {
        <div cdkDropList class="template-list" (cdkDropListDropped)="droppedTemplate($event)">
          @for (template of templates; track template) {
            <div
              class="category-box"
              [class.draggable]="(isAdmin$ | async) || (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async)"
              cdkDrag
              [cdkDragDisabled]="(isAdmin$ | async) ? false : !(hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async)"
              >
              <app-doenkids-image [preview]="true" [mediaItem]="template.media_uuid" [maxWidth]="100"></app-doenkids-image>
              <span>{{ template.name }}</span>
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <h4>{{ 'program.template_bundle.no_templates' | translate }}</h4>
  }

  </div>
</div>
</app-page-content>
